/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

/**
 * Temporal classification of an override for map visualization.
 * Determines the color of the dotted polyline rendered on the map.
 */
export enum EOverrideVisualStatus {
  ACTIVE = 'active',
  PLANNED = 'planned',
  EXPIRED = 'expired'
}
